/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/prototype/extrude 层；
 * 2. 负责定义拉伸族特征的统一原型对象；
 * 3. 凸台拉伸与拉伸切除都应先收口到该基类，再按语义扩展子类。
 *
 * 文件职责：
 * 1. 统一承载拉伸定义对象、来源草图与输入绑定；
 * 2. 为 mesh/result、设计树与编辑会话提供稳定的拉伸族领域对象；
 * 3. 避免 boss/cut 在 prototype 层重复维护同一份骨架逻辑。
 */

import type { FeatureReferenceBinding } from '../../binding/FeatureReferenceBinding';
import { ExtrudeFeatureDefinitionModel } from '../../definition/extrude/ExtrudeFeatureDefinition';
import { FeaturePrototype } from '../FeaturePrototype';

/**
 * 拉伸族特征原型。
 */
export class ExtrudeFeaturePrototype extends FeaturePrototype<ExtrudeFeatureDefinitionModel> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        featureId: string;
        definition: ExtrudeFeatureDefinitionModel;
        bindings: FeatureReferenceBinding[];
        sourceSketchId?: string | null;
    }) {
        super(input);
    }
}
